import { compose, withHandlers } from 'recompose';
import omitProps from '@hocs/omit-props';
var KEYS = {
  ENTER: 13,
  TAB: 9
};
export default compose(withHandlers({
  onKeyDown: function onKeyDown(_ref) {
    var onTab = _ref.onTab,
        onEnter = _ref.onEnter,
        _onKeyDown = _ref.onKeyDown;
    return function (e) {
      switch (e.keyCode) {
        case KEYS.TAB:
          {
            var direction = e.shiftKey ? -1 : 1;
            return onTab(direction, e);
          }

        case KEYS.ENTER:
          {
            return onEnter(e);
          }
      }

      _onKeyDown(e);
    };
  }
}), omitProps('onEnter', 'onTab'));
//# sourceMappingURL=index.js.map